export default __webpack_public_path__ + "KaTeX_Size2-Regular.d1e8ff17527d885764046b575c601f0a.ttf";